import { NgClass } from '@angular/common'
import { Component, input, output } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'dhp-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
  imports: [NgClass, TranslatePipe],
})
export class FiltersComponent {
  readonly categories = input<string[]>([])
  readonly selectedCategory = input<string | null>(null)

  readonly categorySelected = output<string | null>()

  selectCategory(category: string): void {
    this.categorySelected.emit(
      this.selectedCategory() === category ? null : category
    )
  }

  getCategories(): string[] {
    return this.categories()
  }
}
